<template>
  <div v-if="form">
    <div
        class="modal fade"
        :class="form ? 'show' : ''"
        style="display: block"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        @click="dismiss ? $event.target.classList.contains('modal') ? SET_FORM_FILTER(false) : true : true"
    >
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">Filter</h5>
            <button type="button" class="close" @click="SET_FORM_FILTER(false)" v-html="loading ? spin() : ic('close')"/>
          </div>
          <div class="modal-body pt-3">
            <div class="row">
              <div class="form-group col-12">
                <label for="tim" class="form-label">Nama Tim</label>
                <selectize
                    id="tim"
                    v-model="filter.id_tim"
                    @input="_getTim"
                    data-placeholder="Pilih Tim" required :disabled="loading" :settings="selectizeConfig">
                  <option :value="d.id" v-for="(d, i) in tim" :key="i"> {{d.nama_tim}}</option>
                </selectize>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12">
                <label for="brand" class="form-label">Nama brand</label>
                <selectize
                    id="brand"
                    v-model="filter.id_brand"
                    @input="_getBrand"
                    data-placeholder="Pilih Brand" required :disabled="loading" :settings="selectizeConfig">
                  <option :value="d.id" v-for="(d, i) in brand" :key="i"> {{d.nama_brand}}</option>
                </selectize>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12">
                <label for="supervisor" class="form-label">Nama Supervisor</label>
                <selectize
                    id="supervisor"
                    v-model="filter.id_supervisor"
                    @input="_getSupervisor"
                    data-placeholder="Pilih Supervisor" required :disabled="loading" :settings="selectizeConfig">
                  <option :value="d.id" v-for="(d, i) in supervisor" :key="i"> {{d.nama_sales_supervisor}}</option>
                </selectize>
              </div>
            </div>

            <div class="row">
              <div class="form-group col-12">
                <label for="principal" class="form-label">Nama Principal</label>
                <selectize
                    id="principal"
                    v-model="filter.id_principal"
                    @input="_getPrincipal"
                    data-placeholder="Pilih Principal" required :disabled="loading" :settings="selectizeConfig">
                  <option :value="d.id" v-for="(d, i) in principal" :key="i"> {{d.nama_principal}}</option>
                </selectize>
              </div>
            </div>
          
          </div>

          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-white"
                @click="cancel"
                v-html="'Tutup'" />
            <button
                type="button"
                @click="applyFilter"
                :disabled="loading"
                class="btn btn-primary" v-html="'Ok'" />
          </div>

        </div>
      </div>
    </div>

    <div class="modal-backdrop fade" :class="form ? 'show' : ''" />
  </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "Modal",
  mixins: [helper],

  data() {
    return {
      dismiss: {default: true},
      tim: [],
      brand: [],
      supervisor: [],
      principal: [],
      selectizeConfig: {
        maxItems: 99,
        plugins: ["remove_button"]
      },
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('target_salesman', {
      form: state => state.form_filter,
      filter: state => state.filter
    })
  },
  methods: {
    ...mapActions('tim', ['getListTim']),
    ...mapActions('brand', ['getListBrand']),
    ...mapActions('salesman', ['getListSalesmanSpv']),
    ...mapActions('principal', ['getListPrincipal']),
    ...mapActions('target_salesman', ['getTargetSalesman']),
    ...mapMutations('target_salesman', ['SET_FORM_FILTER']),
   
    _getTim() {
      this.getListTim({id_tim: this.filter.id_tim, filter: false}).then( res => {
        this.tim = res
      })
    },
    _getBrand() {
      this.getListBrand({id_brand: this.filter.id_brand, filter: false}).then( res => {
        this.brand = res
      })
    },
    _getSupervisor() {
      this.getListSalesmanSpv({id_supervisor: this.filter.id_supervisor, filter: false}).then( res => {
        this.supervisor = res
      })
    },
    _getPrincipal() {
      this.getListPrincipal({id_principal: this.filter.id_principal, filter: false}).then( res => {
        this.principal = res
      })
    },
    cancel() {
      this.SET_FORM_FILTER(false)
    },
    applyFilter() {
      this.SET_FORM_FILTER(false)
      this.getTargetSalesman(this.filter)
    }
  },
  watch: {
    form(newVal, oldVal) {
      if (newVal === true) {
        if (this.tim.length === 0) this._getTim()
        if (this.brand.length === 0) this._getBrand()
        if (this.supervisor.length === 0) this._getSupervisor()
        if (this.principal.length === 0) this._getPrincipal()
      }
    }
  }
};
</script>
